import DefaultDatepicker, { DatepickerType } from "react-tailwindcss-datepicker";

const DatePicker = (props: DatepickerType) => {
    return (
        <DefaultDatepicker {...props} />
    )
}

export default DatePicker